var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerspectivesPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.55 39.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #8a397e;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.93,
    cy: 13.19,
    r: 7.29,
    transform: "translate(-2.23 15.29) rotate(-22.73)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.87,
    y1: 20.14,
    x2: 44.83,
    y2: 21.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.08,26.34h0c-.63.63-1.65.63-2.28,0l-2.98-2.98c-.63-.63-.63-1.65,0-2.28h0c.63-.63,1.65-.63,2.28,0l2.98,2.98c.63.63.63,1.65,0,2.28Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "15.61 33.69 8.32 33.48 8.61 29.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.91,20.95l-6.99-1.14-4.1,2.29-4.1-2.29-7.07,1.16c-1.69.28-3.05,1.51-3.5,3.16l-.04.14c-.87,3.23-1.24,6.58-1.07,9.93h0c.11,2.32,2.03,4.14,4.35,4.14h9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.71,
    y1: 19.81,
    x2: 13.3,
    y2: 18.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.32,
    y1: 18.43,
    x2: 20.91,
    y2: 19.81
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.55,7.89c.69.28.81.88.77,1.55,0,0-.25,2.11-.91,2.34-.67,2.83-2.49,5.51-5.6,5.51-2.88,0-4.82-2.67-5.56-5.49-.68-.23-.95-2.36-.95-2.36-.04-.67.08-1.28.77-1.55,0,0-.3-4.72,1.64-5.67.67-.33-.08-.92,2.13-1.17,1.84-.21,4.37.18,5.57,1.16.84.69,2.29,1.78,2.14,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.77,3.23s0,2.68,4.55,1.26c2.47-.77,5.56-1.18,6.01.72"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.54 24.1 18.44 24.1 14.39 38.33 37.49 38.33 41.54 24.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspectivesPurple);
export default __webpack_public_path__ + "static/media/perspectives-purple.b9700b504f93645b87736834e6b5d3b8.svg";
export { ForwardRef as ReactComponent };